import React, { Component } from 'react';
import Script from 'react-load-script'

let prodGMAPIKey = "AIzaSyB-2F2SL3_7xCdc8SyzPlj3jo0YUcov8hY"

class MApiCompWraper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    }

    this.handleScriptCreate = this.handleScriptCreate.bind(this);
    this.handleScriptError = this.handleScriptError.bind(this);
    this.handleScriptLoad = this.handleScriptLoad.bind(this);
    this.getExternalScript = this.getExternalScript.bind(this);
  }

  getExternalScript() {
    return <Script
      /// url="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&key=AIzaSyDiWDzyX3RIjyqtvKOunhiezMWjXmqe3LQ"  //Dev 
      url="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&key=AIzaSyB-2F2SL3_7xCdc8SyzPlj3jo0YUcov8hY"  //Prod
      onCreate={this.handleScriptCreate}
      onError={this.handleScriptError}
      onLoad={this.handleScriptLoad}
    />
  }

  handleScriptCreate() {
    // console.log("handleScriptCreate");
  }

  handleScriptError() {
    // this.setState({ scriptError: true })
    console.warn("Can't load Google api")
  }

  handleScriptLoad() {
    //this.initialize();
    this.setState({
      loaded: true
    });
  }

  componentWillMount() {
    this.setState({
      extScript: this.getExternalScript()
    })
  }

  render() {

    const childrenWithProps = React.Children.map(this.props.children,
     (child) => React.cloneElement(child, Object.assign({},{loaded: this.state.loaded}, this.props))
    );

    return (
      <div>
        {this.state.extScript}
        {childrenWithProps}
      </div>
    )
  }
}

export default MApiCompWraper;


// WEBPACK FOOTER //
// ./js/mApiCompWraper.js